import { Component, Input, OnInit } from '@angular/core';
import { AlertColourScheme, AlertStyle } from './alert-enums';
import { materialSymbols } from '../../../shared/constants/material-symbols';

@Component({
  selector: 'app-alert',
  standalone: false,
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
})
export class AlertComponent implements OnInit {

  @Input() alertStyle: AlertStyle = AlertStyle.general
  @Input() showCloseButton: boolean = false;
  @Input() alertHeaderText: string='';
  @Input() alertContentText: string='';

  materialSymbols = materialSymbols;
  alertColourScheme = AlertColourScheme;

  alertIcon?: string;
  colourScheme: AlertColourScheme = AlertColourScheme.grey

  ngOnInit(): void {
    this.setAlertIcon();
  }

  setAlertIcon() {
    switch (this.alertStyle) {
      case AlertStyle.success:
        this.alertIcon = materialSymbols.checkCircle;
        this.colourScheme = AlertColourScheme.green;
        break;
      case AlertStyle.warning:
        this.alertIcon = materialSymbols.warning;
        this.colourScheme = AlertColourScheme.orange;
        break;
      case AlertStyle.error:
        this.alertIcon = materialSymbols.error;
        this.colourScheme = AlertColourScheme.red;
        break;
      case AlertStyle.general:
        this.alertIcon = materialSymbols.notifications;
        this.colourScheme = AlertColourScheme.grey;
        break;
      case AlertStyle.info:
        this.alertIcon = materialSymbols.info;
        this.colourScheme = AlertColourScheme.blue;
        break;               
    }
  }
}



